import PropTypes from 'prop-types';

/**
 * Reusable prop types for view features
 */
const viewerFeaturePropTypes = {
  print: PropTypes.bool.isRequired,
  save: PropTypes.bool.isRequired,
  viewOnlyDisclaimer: PropTypes.bool.isRequired,
};

export default viewerFeaturePropTypes;
